import React from 'react';
import { Modal, Row, Col, Card, Button, Spin } from 'antd';

// Sentinel for "don't add the dataset to any map" (file-manager only).
export const NO_MAP = -1;

interface MapSelectionModalProps {
  visible: boolean;
  onCancel: () => void;
  loadingMaps: boolean;
  allMaps: any[];
  selectedMap: number | null;
  setSelectedMap: (id: number) => void;
  onNext: () => void;
  /** The map the user is currently in — shown first, labelled "Current". */
  currentMapId?: number | string;
  /** Show a "Don't add to a map" option (file-manager only). */
  allowNoMap?: boolean;
}

const stripHtml = (html: string) => html.replace(/<\/?[^>]+(>|$)/g, '');

const MapSelectionModal: React.FC<MapSelectionModalProps> = ({
  visible,
  onCancel,
  loadingMaps,
  allMaps,
  selectedMap,
  setSelectedMap,
  onNext,
  currentMapId,
  allowNoMap = false,
}) => {
  const currentId = currentMapId != null ? Number(currentMapId) : null;
  // Put the current map first and de-dupe it from the rest of the list.
  const orderedMaps =
    currentId != null
      ? [...allMaps.filter((m: any) => Number(m.id) === currentId), ...allMaps.filter((m: any) => Number(m.id) !== currentId)]
      : allMaps;

  return (
    <Modal open={visible} title="SELECT MAP FOR LAYER" onCancel={onCancel} footer={null} width={500} className="mapSelectionModal">
      {loadingMaps ? (
        <div className="loadingContainer">
          <Spin />
        </div>
      ) : (
        <Row gutter={[16, 16]}>
          {orderedMaps.map((map: any) => {
            const isCurrent = currentId != null && Number(map.id) === currentId;
            return (
              <Col span={8} key={map.id}>
                <Card hoverable onClick={() => setSelectedMap(map.id)} className={`mapCard ${selectedMap === map.id ? 'selected' : ''}`}>
                  <h4 className="mapTitle">
                    {stripHtml(map.general.mapTitle)}
                    {isCurrent ? ' (Current)' : ''}
                  </h4>
                </Card>
              </Col>
            );
          })}
          {allowNoMap && (
            <Col span={8} key="no-map">
              <Card hoverable onClick={() => setSelectedMap(NO_MAP)} className={`mapCard ${selectedMap === NO_MAP ? 'selected' : ''}`}>
                <h4 className="mapTitle">Don't add to a map</h4>
              </Card>
            </Col>
          )}
        </Row>
      )}

      <div className="nextButtonContainer">
        {/* selectedMap === NO_MAP is a valid choice, so allow Next then too. */}
        <Button type="primary" disabled={selectedMap == null} onClick={onNext}>
          Next
        </Button>
      </div>
    </Modal>
  );
};

export default MapSelectionModal;
